import { render, staticRenderFns } from "./app_edit.vue?vue&type=template&id=5052aa0d&scoped=true&"
import script from "./app_edit.vue?vue&type=script&lang=js&"
export * from "./app_edit.vue?vue&type=script&lang=js&"
import style0 from "./app_edit.vue?vue&type=style&index=0&id=5052aa0d&lang=scss&scoped=scoped&"
import style1 from "./app_edit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052aa0d",
  null
  
)

export default component.exports